import { RankingType } from 'root/src/shared/creatorDashboard/creatorDashboard.constants';
import { RankLabel } from 'root/src/shared/creatorDashboard/creatorDashboard.types';
export const LEADERBOARD_DEFAULT_RANKING = RankingType.DropsCompletedFrom90Days;
// Ranking-type tabs (shorter labels than the legacy badges).
export const RANKING_TAB_OPTIONS = [
    { value: RankingType.DropsCompletedFrom90Days, label: 'Last 90 days' },
    { value: RankingType.DropCompletedFromAllTime, label: 'All-time' },
    { value: RankingType.ClicksRate, label: 'Click rate' },
];
// Medal accent per rank tier (gold / silver / bronze for the top three, muted for the rest).
export const rankAccent = (rankLabel) => {
    if (rankLabel === RankLabel.Gold) {
        return { textClass: 'text-amber-300', ringClass: 'ring-amber-300/50' };
    }
    if (rankLabel === RankLabel.Silver) {
        return { textClass: 'text-zinc-300', ringClass: 'ring-zinc-300/50' };
    }
    if (rankLabel === RankLabel.Bronze) {
        return { textClass: 'text-orange-400', ringClass: 'ring-orange-400/50' };
    }
    return { textClass: 'text-muted-foreground', ringClass: 'ring-white/10' };
};
// The stat shown per creator depends on the ranking: click rate vs drops completed.
export const creatorStat = (creator) => {
    var _a;
    if (typeof creator.clicksRate !== 'undefined') {
        return { label: 'Click rate', value: `${creator.clicksRate}%` };
    }
    return { label: 'Drops completed', value: String((_a = creator.completedDrops) !== null && _a !== void 0 ? _a : 0) };
};
